<template>
    <div style="height: 100%">
        <div v-if="filters" class="saved-sort-filters faux-fixed" :class="{ 'saved-sort-filters--opened' : showCategoryFilters }">
            <div class="main-filter-container"
                @click.stop="toggleFilters">
                <span class="main-filter">
                    {{ filters[selectedCategoryFilter].product_category_title }}
                </span>
            </div>
            <transition name="fade-fast">
                <div v-if="showCategoryFilters" class="saved-products-filter-container">
                    <a class="close" @click.stop="toggleFilters"></a>
                    <div class="occasion-filter-container further-down">
                        <div class="filter"
                            v-for="(filter, index) in filters"
                            :class="{active: index === selectedCategoryFilter}"
                            @click="setCategoryFilterIndex(index, filter)"
                        >
                            {{ filter.product_category_title }}
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <div class="page-container saved-products-container">
            <transition name="fade">
                <div v-if="!savedProducts || dataLoading"
                    :key="1"
                    class="loading-overlay">
                    <loader></loader>
                </div>
                <div v-else key="2">
                    <div v-if="savedProducts.length < 1">
                        <div class="no-results-message">
                            You currently don't have any saved items {{ savedProductsCount > 0 ? 'with those filters' : '' }}
                        </div>
                    </div>
                    <div v-else class="saved-items-container">
                        <transition-group name="fade" mode="out-in" :duration="{ enter: 200, leave: 100 }">
                            <div class="products-list-view" :key="1">
                                <saved-product-item
                                    v-for="(product) in savedProducts"
                                    :key="product.product_id"
                                    v-bind:product="product"
                                    @data-loading="productLoading" 
                                    @requested-swap="handleSwapRequest"
                                    @unsave="openUnsaveModal"/>
                            </div>
                        </transition-group>
                    </div>
                </div>
            </transition>
        </div>
        <div @click.stop="$router.go(-1)" class="back-button">
            Back
        </div>

        <transition name="fade">
            <swap-item
                v-if="showSwapProduct"
                :product="swapProduct"
                :showSizes="true"
                :swapCb="onSwapProduct"
                @close="showSwapProduct = false"
            />
        </transition>

        <unsave-item-modal v-if="unsaveModalOpened" itemType="product" :confirm="unsaveProduct" :close="closeUnsaveModal" :loading="unsaveLoading" />
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Mixins from '../../mixins/mixins';
    import { RETURN_PAGE_SAVED_ITEMS } from "../../config.js";
    import SavedProductItem from "./saved-product-item.vue";
    import Loader from '../common/loader.vue';
    import SwapItem from '../products/swap-item.vue';
    import $ from 'webpack-zepto';
    import UnsaveItemModal from './unsave-item-modal.vue';

    export default {
        data() {
            return {
                pageNumber: 2,
                dataLoading: true,
                showCategoryFilters: false,
                showSwapProduct: false,
                swapProduct: null,
                unsaveModalOpened: false,
                unsaveLoading: false,
                productToUnsave: null,
            }
        },
        mixins: [Mixins],
        components: {
            Loader,
            SavedProductItem,
            SwapItem,
            UnsaveItemModal,
        },
        computed: {
            ...mapGetters({
                savedProducts: 'savedProducts/savedProducts',
                selectedCategoryFilter: 'filters/selectedSavedProductsCategoryFilterIndex',
                filters: 'filters/savedProductFilters',
                savedProductsCount: 'savedProducts/savedProductsCount',
            })
        },
        methods: {
            toggleFilters() {
                this.showCategoryFilters = !this.showCategoryFilters;
            },
            setCategoryFilterIndex(index, filter) {
                this.$store.commit('filters/setSelectedSavedProductsCategoryFilter', {index, filter});
                this.showCategoryFilters = false;
                this.fetchSavedProducts();
            },
            fetchSavedProducts() {
                this.dataLoading = true;
                Promise.all([
                    this.$store.dispatch('savedProducts/fetchSavedProducts'),
                    (() => {
                        if(!this.filters || this.filters.length === 0) return this.$store.dispatch('filters/fetchSavedProductFilters');
                    })()
                ]).catch(() => {
                    console.log('error loading saved outfits');
                }).finally(() => {
                    this.dataLoading = false;
                });
            },
            handleSwapRequest(product) {
                this.swapProduct = product;
                this.showSwapProduct = true;
            },
            onSwapProduct(subtituteProduct) {
                const index = this.savedProducts.findIndex(savedProduct => savedProduct.product_id == this.swapProduct.product_id);
                return Promise.all([
                    this.$store.dispatch('savedProducts/scoreProduct', {
                        product: subtituteProduct,
                        score: 1,
                        index,
                    }),
                    this.$store.dispatch('savedProducts/scoreProduct', {
                        product: this.swapProduct,
                    }),
                ]);
            },
            productLoading(isLoading) {
                this.dataLoading = isLoading;
            },
            unsaveProduct() {
                this.unsaveLoading = true;

                this.$store.dispatch({
                    type: "savedProducts/scoreProduct",
                    product: this.productToUnsave,
                    score: 0,
                }).finally(this.closeUnsaveModal);
            },
            openUnsaveModal(product) {
                this.unsaveModalOpened = true;
                this.productToUnsave = product;
            },
            closeUnsaveModal() {
                this.unsaveModalOpened = false;
                this.productToUnsave = null;
                this.unsaveLoading = false;
            },
        },
        created() {
            this.$store.commit('menu/setReturnPage', RETURN_PAGE_SAVED_ITEMS);
            this.fetchSavedProducts();
        },
    }
</script>